( function () {
   
    'use strict';

    ( function ( $ ) {
     
        $(".fixtures-tab").click(function () {
            if ($(this).hasClass('active')) {
            } else {
              var tabid = $(this).attr('id');
              $(".fixtures-tab").removeClass('active');
              $(this).addClass('active');
              $(".fixtures-tab-content").removeClass('active');
              $("#" + tabid + "-content").addClass("active");
            }
            return false;
        });
        $(".fixtures-result-tab").click(function () {
          if ($(this).hasClass('active')) {
          } else {
            var tabid = $(this).attr('id');
            $(".fixtures-result-tab").removeClass('active');
            $(this).addClass('active');
            $(".fixtures-result-tab-content").removeClass('active');
            $("#" + tabid + "-content").addClass("active");
          }
          return false;
        });
        $(".fixtures-men-women-tab").click(function () {
          if ($(this).hasClass('active')) {
          } else {
            var tabid = $(this).attr('id');
            $(".fixtures-men-women-tab").removeClass('active');
            $(this).addClass('active');
            $(".fixtures-men-women-tab-content").removeClass('active');
            $("#" + tabid + "-content").addClass("active");
          }
          return false;
      });
        $(".fixtures-right-tab").click(function () {
            if ($(this).hasClass('active')) {
            } else {
              var tabid = $(this).attr('id');
              $(".fixtures-right-tab").removeClass('active');
              $(this).addClass('active');
              $(".fixtures-right-tab-content").removeClass('active');
              $("#" + tabid + "-content").addClass("active");
            }
            return false;
        });
        $(".fixtures-table-tab").click(function () {
          if ($(this).hasClass('active')) {
          } else {
            var tabid = $(this).attr('id');
            $(".fixtures-table-tab").removeClass('active');
            $(this).addClass('active');
            $(".fixtures-table-tab-content").removeClass('active');
            $("#" + tabid + "-content").addClass("active");
          }
          return false;
      });
      $(".fixtures-results-tab").click(function () {
        if ($(this).hasClass('active')) {
        } else {
          var tabid = $(this).attr('id');
          $(".fixtures-results-tab").removeClass('active');
          $(this).addClass('active');
          $(".fixtures-results-tab-content").removeClass('active');
          $("#" + tabid + "-content").addClass("active");
        }
        return false;
    });
        $(".fixtures-last-tab").click(function () {
            if ($(this).hasClass('active')) {
            } else {
              var tabid = $(this).attr('id');
              $(".fixtures-last-tab").removeClass('active');
              $(this).addClass('active');
              $(".fixtures-last-tab-content").removeClass('active');
              $("#" + tabid + "-content").addClass("active");
            }
            return false;
        });
        $(".fixtures-women-tab").click(function () {
          if ($(this).hasClass('active')) {
          } else {
            var tabid = $(this).attr('id');
            $(".fixtures-women-tab").removeClass('active');
            $(this).addClass('active');
            $(".fixtures-women-tab-content").removeClass('active');
            $("#" + tabid + "-content").addClass("active");
          }
          return false;
      });
        
        $(".fixtures-tables-tab").click(function () {
          if ($(this).hasClass('active1')) {
          } else {
            var tabid = $(this).attr('id');
            $(".fixtures-tables-tab").removeClass('active1');
            $(this).addClass('active1');
            $(".fixtures-tables-tab-content").removeClass('active1');
            $("#" + tabid + "-content").addClass("active1");
          }
          return false;
      });
          $(".fixtures-right-blog-new").slice(0,4).show();
          $("#seeMore").click(function(e){
            e.preventDefault();
            $(".fixtures-right-blog-new:hidden").slice(0,4).fadeIn("slow");
            
            if($(".fixtures-right-blog-new:hidden").length == 0){
              $("#seeMore").fadeOut("slow");
              }
          });
    } )( jQuery );
} )();

